<template>
  <div v-if="body_show" class="base-class-main">
    <img class="ban" src="@a/other/base_class/base_class_ban.png" />
    <div class="base-class-box">
      <div class="base-select-group">
        <div
          class="input"
          :class="{on:class_name}"
          @click="pickerShow=true"
        >{{class_name?class_name:'请选择自己的班级'}}</div>
        <img src="@a/other/base_class/base_class_bottom.png" @click="pickerShow=true" />
      </div>
      <div class="base-input-group">
        <form action="javascript:;">
          <input
            type="text"
            v-model="phone"
            placeholder="请输入自己的手机号"
            ref="inp"
            @keyup.13="tapToSearch"
          />
        </form>
      </div>
      <!-- 查询按钮 -->
      <a @click="tapToSearch" class="beginBtn">查&nbsp;&nbsp;&nbsp;询</a>
    </div>
    <!-- 下拉窗口 -->
    <van-popup class="popup" v-model="pickerShow" position="bottom">
      <van-picker
        show-toolbar
        :columns="list"
        :default-index="0"
        @cancel="pickerShow=false"
        @confirm="pickerCfm"
      />
    </van-popup>
    <!-- 查询失败展示 -->
    <van-popup class="popup-fa" v-model="failureShow">
      <div class="fa-box">
        <h3>查找失败</h3>
        <p>
          暂未查询到您的个人信息，如果您已报名课程可联系小班咨询,
          <span>在班级群中@当期小班即可</span>
        </p>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { getClassname, search } from "@/api/other";
import { phoneValidation } from "@/utils/validation";
export default {
  data() {
    return {
      body_show: false,
      list: [],
      pickerShow: false,
      class_name: "",
      phone: null,
      failureShow: false
    }
  },
  methods: {
    // 查询
    tapToSearch() {
      this.$refs.inp.blur();
      if (!this.class_name || !this.phone) {
        this.$toast("班级或手机号信息不能为空！");
        return;
      } else if (!phoneValidation(this.phone)) {
        this.$toast("请输入正确的手机号！");
        return;
      }
      //调用加载中
      this.$emit("loadingHandle", true, "查询中...");
      search({
        class_name: this.class_name,
        phone: this.phone
      }).then(data => {
        //关闭加载中
        this.$emit("loadingHandle", false);
        if (data.code == "10002") {
          this.failureShow = true;
          return;
        }
        this.$router.push({
          path: "/online_base_userinfo",
          query: {
            name: this.class_name,
            phone: this.phone
          }
        });
      });
    },
    /*
     *@Description: 下拉选择的值
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2020年4月11日
     */
    pickerCfm(picker) {
      if (picker.length == 0) {
        this.$toast("暂无班级信息！");
        this.class_name = "";
      } else {
        this.class_name = picker;
      }

      this.pickerShow = false;
    },
    // 初始化方法
    pullData() {
      //调用加载中
      this.$emit("loadingHandle", true, "拼命加载中...");
      getClassname().then(data => {
        this.list = data.list;

        document.title = "查询个人信息";
        this.body_show = true;
        //关闭加载中
        this.$emit("loadingHandle", false);
      });
    }
  },
  created() {
    this.pullData();
  }
};
</script>

<style lang="scss" scoped>
.base-class-main {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  background-color: #fff;
  .ban {
    width: 100%;
    height: 354px;
  }
  .base-class-box {
    padding: 80px 70px;
    .base-select-group {
      position: relative;
      margin-bottom: 40px;
      .input {
        width: 100%;
        height: 80px;
        line-height: 80px;
        border: 2px solid rgba(28, 149, 212, 1);
        border-radius: 40px;
        padding: 0 22px;
        box-sizing: border-box;
        background-color: #fff;
        font-size: 26px;
        color: #999;
        cursor: pointer;
      }
      .input.on {
        color: #333;
      }
      img {
        width: 27px;
        height: 16px;
        position: absolute;
        right: 22px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .base-input-group {
      input {
        width: 100%;
        line-height: 80px;
        border: 2px solid rgba(28, 149, 212, 1);
        border-radius: 40px;
        padding: 0 22px;
        box-sizing: border-box;
        font-size: 26px;
        color: #333;
      }
    }
    .beginBtn {
      font-size: 32px;
      width: 578px;
      line-height: 80px;
      color: #fff;
      background: rgba(28, 149, 212, 1);
      border-radius: 40px;
      display: block;
      text-align: center;
      border: 1px solid;
      margin: 160px auto 20px;
    }
  }
}
.popup-fa {
  background: transparent;
  .fa-box {
    width: 480px;
    border-radius: 8px;
    padding: 50px 45px;
    background-color: #fff;
    h3 {
      font-size: 34px;
      color: #1c95d4;
      text-align: center;
      line-height: 1;
      margin-bottom: 35px;
    }
    p {
      font-size: 26px;
      color: #333333;
      text-align: center;
      line-height: 39px;
      span {
        color: #1c95d4;
      }
    }
  }
}
</style>